import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import { formActions, httpRequestsOnSuccessActions, noteActions } from 'store';
import { CustomDelete } from '..';
import { noteHead, noteBody, ACTION_TYPE, noteNotYet } from '../constants';
import { FindSuccessItem, Images, RolePermission, useModal, User, useSecondaryModal } from 'utils';
import { FullTable } from '../../tabs';
import { NoteInfo } from './noteInfo';
import { AddCircleBlue } from '../../buttons';
import { AddNoteForm } from './addNoteForm';
import { formBuilderStatusEnums } from 'pages/forms/constants';
import { NoteHistoryModal } from './noteHistoryModal';

const DELETE_ACTION_TYPE = 'DELETE_GLOBAL_NOTE';
export const Notes = ({ id, onModel, formModel, permissions, tableMargin, saveParams }) => {
    const dispatch = useDispatch();
    const { userInfo } = User();
    const navigate = useNavigate();
    const location = useLocation();
    const [filters, setFilters] = useState({
        skip: 0,
    });
    const info = saveParams ? filters : location?.state;
    const deleteSuccess = FindSuccessItem(DELETE_ACTION_TYPE);
    const { open } = useModal();
    const { openSecondary } = useSecondaryModal();
    const notes = useSelector((state) => state.note.notes);

    useEffect(() => {
        dispatch(formActions.resetForms());
    }, []);

    useEffect(() => {
        if (RolePermission([...permissions])) {
            dispatch(formActions.getForms({ model: formModel, status: formBuilderStatusEnums.PUBLISHED }));
        }
    }, []);

    useEffect(() => {
        getNotes();
    }, [info]);

    const requestParams = () => {
        const pushInfo = {
            ...info,
        };
        delete pushInfo.page;
        delete pushInfo.activeTab;
        return { ...pushInfo };
    };

    const getNotes = (loading) => {
        const pushInfo = {
            ...requestParams(),
        };
        const load = loading === 'noLoad' ? 'noLoad' : 'load';
        dispatch(noteActions.getGlobalNotes(id, onModel, { ...pushInfo }, load));
    };

    useEffect(() => {
        if (deleteSuccess) {
            getNotes('noLoad');
            dispatch(httpRequestsOnSuccessActions.removeSuccess(DELETE_ACTION_TYPE));
        }
    }, [deleteSuccess]);

    const handleClick = (id, item) => {
        open(<NoteInfo note={item} handleAction={(value, action) => handleClickButton(value, action)} permissions={permissions} />, { styles: { bodyStyle: {padding: '24px 48px'}}});
    };

    const handleClickButton = (item, name) => {
        if (name === 'deleteNote') {
            open(
                <CustomDelete
                    text="Are you sure you want to delete this note? This action cannot be undone."
                    info="Delete Note"
                    handleDel={() => dispatch(noteActions.deleteGlobalNote(item?.id, requestParams))}
                    actionType={DELETE_ACTION_TYPE}
                    body={
                        <div className="deleting-client-info-box" style={{ alignItems: 'flex-start' }}>
                            <img style={{ marginTop: '3px' }} src={Images.editBlack} alt="icon" />
                            <p style={{ fontWeight: 400 }}>{item?.template?.title}</p>
                        </div>
                    }
                />
            );
        }
        if (name === 'editNote' || name === 'edit') {
            open(<AddNoteForm noteModal={onModel} formModel={formModel} resourceId={id} info={item} requestParams={requestParams()} />, { styles: { bodyStyle: {padding: '24px 48px'}}});
        }
        if(name === 'viewHistory'){
            openSecondary(<NoteHistoryModal noteId={item?.id} />);
        }
    };

    return (
        <div>
            {RolePermission([...permissions]) && (
                <div className="header-action-btn">
                    <AddCircleBlue
                        type="button"
                        text={'Add Note'}
                        handleClick={() =>
                            open(<AddNoteForm resourceId={id} noteModal={onModel} formModel={formModel} requestParams={requestParams()} />, { styles: { bodyStyle: {padding: '24px 48px'}}})
                        }
                    />
                </div>
            )}
            <FullTable
                savedParams={saveParams ? filters : null}
                getParams={saveParams ? (e) => setFilters(e) : null}
                margin={tableMargin ? tableMargin : '0'}
                head={noteHead(permissions)}
                body={noteBody(permissions, userInfo)}
                loadingType={ACTION_TYPE}
                list={notes?.data}
                handleClick={handleClick}
                handleClickButton={handleClickButton}
                notYet={noteNotYet}
            />
        </div>
    );
};
